import "firebase/compat/firestore";
import firebase from "firebase/compat/app";

class ModelCommon {
    static isNull = (text) => {
        if ((typeof text == "undefined") || (text == null)) {
            return true;
        }
        else {
            return false;
        }
    }
    static toNumber = (text, isNotNull) => {
        if (this.isNull(text)) {
            if (isNotNull) {
                return 0;
            }
            else {
                return null;
            }
        }
        else {
            return text * 1;
        }
    }
    static toText = (number, isNotNull) => {
        if (this.isNull(number)) {
            if (isNotNull) {
                return '';
            }
            else {
                return null;
            }
        }
        else {
            return number + '';
        }
    }
    static toList = (value, isNotNull) => {
        if (this.isNull(value)) {
            if (isNotNull) {
                return [];
            }
            else {
                return null;
            }
        }
        else {
            return value;
        }
    }
    static toMap = (value, isNotNull) => {
        if (this.isNull(value)) {
            if (isNotNull) {
                return {};
            }
            else {
                return null;
            }
        }
        else {
            return value;
        }
    }
    static toSafeValue = (value) => {
        if (this.isNull(value)) {
            return null;
        }
        else {
            return value;
        }
    }
    static toTimestamp = (value) => {
        if (this.isNull(value)) {
            return null;
        }
        else if (value.toDate === 'function') {
            return value;
        }
        else {
            return new firebase.firestore.Timestamp(value.seconds, value.nanoseconds);
        }
    }
}

export default ModelCommon;